// employeeTdsContributionAction.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import payrollServiceApiInstance from "../../../../../config/payrollApiConfig";

// 🔹 Create
export const createEmployeeTdsContribution = createAsyncThunk(
  "employeeTdsContribution/create",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post("/tds-contributions", payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 🔹 Get All
export const fetchEmployeeTdsContributions = createAsyncThunk(
  "employeeTdsContribution/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get("/tds-contributions");
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 🔹 Get By ID
export const fetchEmployeeTdsContributionById = createAsyncThunk(
  "employeeTdsContribution/fetchById",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/tds-contributions/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 🔹 Update
export const updateEmployeeTdsContribution = createAsyncThunk(
  "employeeTdsContribution/update",
  async (
    { id, payload }: { id: number; payload: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await payrollServiceApiInstance.put(`/tds-contributions/${id}`, payload);
      return { id, ...response.data };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 🔹 Delete
export const deleteEmployeeTdsContribution = createAsyncThunk(
  "employeeTdsContribution/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/tds-contributions/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
